<template>
  <div id="message-panel" class="mt-6">
    <div class="text-grey-darken-4 font-weight-bold mb-2">
      {{ i18n.t('titles.message_to_all_participants') }}
    </div>
    <v-textarea
      v-model="message"
      data-test-id="add-message"
      hide-details
      :label="i18n.t('labels.add_message')"
      variant="outlined"
      @blur="updateSimpleDocumentMessage"
      @focus="setInitialMessage"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useEmitter } from '@/composables/useEmitter';
import { useI18n } from 'vue-i18n';
import { useDocumentContext } from '@/composables/useDocumentContext';

defineProps({
  forRequestor: {
    type: Boolean,
    default: true
  }
});

const { currentDocument } = useDocumentContext();

const message = ref(
  currentDocument.value
    ? currentDocument.value.comment?.replaceAll('<br />', '\n')
    : ''
);
const initialMessage = ref('');
const emitter = useEmitter();
const i18n = useI18n();

function setInitialMessage() {
  if (message.value) {
    initialMessage.value = message.value;
  }
}

function updateSimpleDocumentMessage() {
  if (message.value !== initialMessage.value) {
    if (message.value) {
      const newMessage = message.value.replaceAll('\n', '<br />');
      emitter.$emit('update-signature-message', newMessage);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.mobile-container {
  padding: 12px 20px 40px 20px;
  max-width: 100%;
}

.no-padding {
  padding: 0;
}

.sub-expansion-panel-content :deep(.v-expansion-panel-content__wrap) {
  margin-top: 8px;
  padding: 0 !important;
}
</style>
